module.exports = __webpack_public_path__ + "static/img/money-02.6f90939.png";